import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { useTheme } from 'styled-components';

import { Typography } from 'common/typography';
import { isEmployeeEmail } from 'modules/login/utils';

import EmailLoginSuccessState from './EmailLoginSuccessState';
import LoginBox from './LoginBox';
import ShoppingBagImg from './images/ShoppingBag.png';

const LandingPageContainer = styled.div`
  height: 100%;
  padding: 0 2rem 2rem;
`;

const Center = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
`;

const LandingPageBgImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
  height: 18vh;

  @media (height <= 600px) {
    height: 10vh;
  }

  @media (height <= 500px) {
    display: none;
  }
`;

const WoltForMerchantsContainer = styled(Typography.Heading1)`
  margin-block-end: 8px;
  color: ${cbSemanticCssVars.textPrimary};
`;

const WelcomeSignInContainer = styled(Typography.Body1)`
  color: ${cbSemanticCssVars.textPrimary};
`;

const EmailWithoutPasswordContainer = styled.div`
  padding: 24px 0;
`;

const LandingPage = () => {
  const [email, setEmail] = useState<string>('');
  const isEmployee = useMemo(() => isEmployeeEmail(email), [email]);
  const [isEmailLoginSuccess, setIsEmailLoginSuccess] = useState<boolean>(false);
  const theme = useTheme();

  return (
    <LandingPageContainer data-testid="landing-page-v2">
      <LandingPageBgImage src={ShoppingBagImg} />

      <Center dir={theme.cbDirection}>
        <div>
          <WoltForMerchantsContainer>
            <FormattedMessage id="landingPage.woltForMerchants" />
          </WoltForMerchantsContainer>
          <WelcomeSignInContainer>
            <FormattedMessage id="login.welcomeSignIn" />
          </WelcomeSignInContainer>
          {isEmailLoginSuccess ? (
            <EmailWithoutPasswordContainer>
              <EmailLoginSuccessState email={email} onBack={() => setIsEmailLoginSuccess(false)} />
            </EmailWithoutPasswordContainer>
          ) : (
            <LoginBox
              email={email}
              isEmployee={isEmployee}
              onEmailChange={setEmail}
              onEmailLoginSuccess={() => setIsEmailLoginSuccess(true)}
            />
          )}
        </div>
      </Center>
    </LandingPageContainer>
  );
};
export default LandingPage;
